import {PaymentProviderType} from "@/types/Providers";
import {IInstallmentDetail} from "@/types/IInstallment";
import {AnalyticEventName} from "@/helpers/google-analytics.helpers";

export const ActionLogTypeConst = {
    LOGIN: "Login",
    QUERY_INSTALLMENTS: "Query_Installments",
    QUERY_PROVIDERS: "Query_Providers",
    GENERATE_REFERENCE: "Generate_Reference",
    SELECT_INSTALLMENT: "Select_Installment",
    SELECT_PROVIDER: "Select_Provider",
    BUTTON_CLICK: "Button_Click",
    PAGE_VIEW: "Page_View",
    ERROR: "Error",
    UserInteraction: "User_Interactions",
    FormSubmission: "Form_Submission",
}

export type ActionLogType = typeof ActionLogTypeConst[keyof typeof ActionLogTypeConst];

export interface IActionLogsRequest {
    deviceTag: string;
    country?: string;
    productType?: PaymentProviderType;
    actionType: ActionLogType;
    action: AnalyticEventName;
    data?: Record<string, any>;
}

export interface IActionLogsResponse {
    id?: number;
    device_tag?: string;
    country?: string;
    product_type?: PaymentProviderType;
    event_datetime?: string;
    action_type?: ActionLogType;
    action?: string;
    app_version?: string;
    selected_installment?: IInstallmentDetail;
    payload?: IActionLogsRequest;
    exported?: boolean;
    created?: string;
    modified?: string | null;
    created_by?: number;
    modified_by?: number | null;
}
